/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      name
      email
      contact
      phone
      address
      enabledMFA
      description
      accountType
      isLocked
      isActive
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        email
        contact
        phone
        address
        enabledMFA
        description
        accountType
        isLocked
        isActive
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserByEmail = /* GraphQL */ `
  query GetUserByEmail(
    $email: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getUserByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        contact
        phone
        address
        enabledMFA
        description
        accountType
        isLocked
        isActive
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSensor = /* GraphQL */ `
  query GetSensor($id: ID!) {
    getSensor(id: $id) {
      id
      apiGroupId
      groupId
      managementId
      name
      status
      lat
      lng
      location
      description
      tx
      isLocked
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSensors = /* GraphQL */ `
  query ListSensors(
    $filter: ModelSensorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSensors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        apiGroupId
        groupId
        managementId
        name
        status
        lat
        lng
        location
        description
        tx
        isLocked
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSensorGroups = /* GraphQL */ `
  query ListSensorGroups(
    $filter: ModelSensorGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSensorGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSensorHistory = /* GraphQL */ `
  query GetSensorHistory($sensorId: ID!, $createdAt: AWSDateTime!) {
    getSensorHistory(sensorId: $sensorId, createdAt: $createdAt) {
      sensorId
      status
      lat
      lng
      createdAt
      tx
      payload
      data
      updatedAt
      __typename
    }
  }
`;
export const listSensorHistorys = /* GraphQL */ `
  query ListSensorHistorys(
    $sensorId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelSensorHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSensorHistorys(
      sensorId: $sensorId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        sensorId
        status
        lat
        lng
        createdAt
        tx
        payload
        data
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCameraSensorHistory = /* GraphQL */ `
  query GetCameraSensorHistory($sensorId: ID!, $tx: AWSDateTime!) {
    getCameraSensorHistory(sensorId: $sensorId, tx: $tx) {
      sensorId
      keyImage
      tx
      isAnalyzed
      status
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCameraSensorHistories = /* GraphQL */ `
  query ListCameraSensorHistories(
    $sensorId: ID
    $tx: ModelStringKeyConditionInput
    $filter: ModelCameraSensorHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCameraSensorHistories(
      sensorId: $sensorId
      tx: $tx
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        sensorId
        keyImage
        tx
        isAnalyzed
        status
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const queryBySensorIdIsAnalyzed = /* GraphQL */ `
  query QueryBySensorIdIsAnalyzed(
    $sensorId: ID!
    $isAnalyzedTx: ModelCameraSensorHistorySensorIdIsAnalyzedIndexCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCameraSensorHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    queryBySensorIdIsAnalyzed(
      sensorId: $sensorId
      isAnalyzedTx: $isAnalyzedTx
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        sensorId
        keyImage
        tx
        isAnalyzed
        status
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSensorChangeHistory = /* GraphQL */ `
  query GetSensorChangeHistory($sensorId: ID!, $createdAt: AWSDateTime!) {
    getSensorChangeHistory(sensorId: $sensorId, createdAt: $createdAt) {
      sensorId
      status
      lat
      lng
      createdAt
      tx
      payload
      data
      updatedAt
      __typename
    }
  }
`;
export const listSensorChangeHistorys = /* GraphQL */ `
  query ListSensorChangeHistorys(
    $sensorId: ID
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelSensorChangeHistoryFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSensorChangeHistorys(
      sensorId: $sensorId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        sensorId
        status
        lat
        lng
        createdAt
        tx
        payload
        data
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      startDate
      endDate
      content
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        startDate
        endDate
        content
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCameraTrafficVolumn = /* GraphQL */ `
  query GetCameraTrafficVolumn($cameraId: ID!, $timestamp: AWSDateTime!) {
    getCameraTrafficVolumn(cameraId: $cameraId, timestamp: $timestamp) {
      cameraId
      timestamp
      data
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCameraTrafficVolumns = /* GraphQL */ `
  query ListCameraTrafficVolumns(
    $cameraId: ID
    $timestamp: ModelStringKeyConditionInput
    $filter: ModelCameraTrafficVolumeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCameraTrafficVolumns(
      cameraId: $cameraId
      timestamp: $timestamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cameraId
        timestamp
        data
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserDeviceGroups = /* GraphQL */ `
  query GetUserDeviceGroups($userId: ID!) {
    getUserDeviceGroups(userId: $userId) {
      userId
      group1 {
        name
        __typename
      }
      group2 {
        name
        __typename
      }
      group3 {
        name
        __typename
      }
      group4 {
        name
        __typename
      }
      group5 {
        name
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserDeviceGroups = /* GraphQL */ `
  query ListUserDeviceGroups(
    $userId: ID
    $filter: ModelUserDeviceGroupsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserDeviceGroups(
      userId: $userId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        userId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
